import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=64cdf4c8&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64cdf4c8')) {
      api.createRecord('64cdf4c8', component.options)
    } else {
      api.reload('64cdf4c8', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=64cdf4c8&", function () {
      api.rerender('64cdf4c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HG6M6uozGXUM/JS/comp/DateRangeExt.vue"
export default component.exports